'use client'

import { Link } from '@/i18n/routing'

import { LoggedOutNav } from './LoggedOutNav'
import { NavbarWrapper } from './NavbarWrapper'

export default function Navbar() {
  const logoSrc = '/assets/images/logo-gold.svg'

  return (
    <NavbarWrapper className="dark bg-card">
      <Link href="/" className="text-lg font-bold shrink-0">
        <img src={logoSrc} alt="UNX" className="h-5" />
      </Link>
      <LoggedOutNav />
    </NavbarWrapper>
  )
}
